import {Listing} from "pages/app/completeProfile/listing/Listing"
import {PayoutMethod} from "pages/app/completeProfile/PayoutMethod"
import {PhotosPage} from "pages/app/completeProfile/PhotosPage"
import {Policies} from "pages/app/completeProfile/policies/Policies"
import {SchedulePage} from "pages/app/completeProfile/schedulePage/SchedulePage"
import {TypeAndPrice} from "pages/app/completeProfile/TypeAndPrice"
import {ProtectedRoute} from "ui/base/protectedRoute/ProtectedRoute"
import {CompleteProfileRoot} from "./completeProfile/CompleteProfileRoot"
import {Welcome} from "./welcome/Welcome";

const basePath = "/app"

export const createRoute = (path) => ({
    fullPath: `${basePath}${path}`,
    relativePath: path.slice(path.lastIndexOf("/") + 1),
})

export const appRoute = {
    index: "/app",
    completeProfile: createRoute("/complete-profile"),
    completeProfileSecond: createRoute("/complete-profile/second"),
    completeProfileThird: createRoute("/complete-profile/third"),
    completeProfileFourth: createRoute("/complete-profile/fourth"),
    completeProfileFifth: createRoute("/complete-profile/fifth"),
    completeProfileSixth: createRoute("/complete-profile/sixth"),
    completeProfileSeventh: createRoute("/complete-profile/seventh"),

    // unused links have to be deleted later
    createAccount: createRoute("/create-account"),
    login: createRoute("/login"),
    forgotPassword: createRoute("/login/forgot-password"),
    passwordResetOtp: createRoute("/login/password-reset-otp"),
    resetPassword: createRoute("/login/reset-password"),
    resetPasswordSuccess: createRoute("/login/reset-password-success"),
    otp: createRoute("/otp"),
    welcomeUser: createRoute("/welcome-user"),
    welcome: createRoute("/welcome"),
}

export const appRouter = [
    {
        path: appRoute.welcome.relativePath,
        element: (
            <ProtectedRoute>
                <Welcome />
            </ProtectedRoute>
        ),
    },
    {
        path: appRoute.completeProfile.relativePath,
        element: (
            <ProtectedRoute>
                <CompleteProfileRoot/>
            </ProtectedRoute>
        ),
        children: [
            {index: true, element: <Listing/>},
            {
                path: appRoute.completeProfileSecond.relativePath,
                element: <TypeAndPrice/>,
            },
            {
                path: appRoute.completeProfileThird.relativePath,
                element: <Policies/>,
            },
            {
                path: appRoute.completeProfileFourth.relativePath,
                element: <PhotosPage/>,
            },
            {
                path: appRoute.completeProfileFifth.relativePath,
                element: <SchedulePage/>,
            },
            {
                path: appRoute.completeProfileSixth.relativePath,

                element: <PayoutMethod/>,
            },
        ],
    },
]
